@let job = this.job();

@if (job) {
    <div [ngClass]="{ 'ion-margin-top': topMargin(), 'ion-margin-bottom': bottomMargin() }">
        <lib-card [button]="button()" (cardClicked)="click()">
            @if (job.event_type) {
                <div
                    ngProjectAs="header"
                    class="margin-bottom-small flex align-items-center justify-content-space-between">
                    <div class="flex align-items-center">
                        @if (job.client.photo_url) {
                            <lib-avatar-image
                                class="margin-right-small"
                                [customSize]="48"
                                [image]="job.client.photo_url" />
                        }
                        <h2>{{ job.event_type }}</h2>
                    </div>
                    @if (type() === 'schedule-pending' || type() === 'schedule-confirmed') {
                        <div>
                            <p class="text-midsmall">
                                <span class="text-primary h4 font-weight-medium">{{ job.rate | currencyCustom }}</span>
                                / hour
                            </p>
                        </div>
                    }
                    @if (type() === 'schedule-history') {
                        <lib-status-chip type="job" [status]="job.status" />
                    }
                </div>
            }

            <div>
                @for (date of renderedShiftDates(); track date; let index = $index) {
                    @if (index < maxDateChips()) {
                        <div class="chip-item chip-white chip-small">
                            <p>
                                @if (date === dateToday()) {
                                    Today
                                } @else {
                                    {{ date | date }}
                                }
                            </p>
                        </div>
                    }
                }

                @if (job.shifts && job.shifts.length >= maxDateChips()) {
                    <div class="chip-item chip-white chip-small"><p>& more dates</p></div>
                }

                @for (shiftTime of renderedShiftTimes(); track shiftTime.start_time) {
                    <div class="chip-item chip-white chip-small">
                        <p>
                            {{ shiftTime.start_date + ' ' + shiftTime.start_time | date: 'h:mma' | lowercase }} -
                            {{ shiftTime.end_date + ' ' + shiftTime.end_time | date: 'h:mma' | lowercase }}
                        </p>
                    </div>
                }

                @if (displayDistance()) {
                    <div class="chip-item chip-white chip-small">
                        <p>{{ job.distance_from_job }} mi from you</p>
                    </div>
                }
            </div>

            @if (type() === 'available' && (displayRelativeDate() || displayRate())) {
                <div class="ion-margin-top flex justify-content-space-between">
                    <div>
                        <p class="text-midsmall">{{ job.updated_at || job.created_at || '' | relativeTime }}</p>
                    </div>
                    <div>
                        <p class="text-midsmall">
                            <span class="text-primary h4 font-weight-medium">{{ job.rate | currencyCustom }}</span>
                            / hour
                        </p>
                    </div>
                </div>
            }
        </lib-card>
    </div>
}
